"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var _default = exports["default"] = (0, _reactIntl.defineMessages)({
  completedStepSuffix: {
    id: 'components.Step.completedStepSuffix',
    defaultMessage: '{label}, completo'
  },
  currentStepSuffix: {
    id: 'components.Step.currentStepSuffix',
    defaultMessage: '{label}, atual'
  },
  incompletedStepSuffix: {
    id: 'components.Step.incompletedStepSuffix',
    defaultMessage: '{label}, incompleto'
  }
});